import { AxiosInstance } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { extractError } from "utility/utils";

import { ReceiptData } from "./receipt-state";
import * as requestUrl from "../../constants/request";
import { ThunkAPIConfig } from "store";
import { addNotification } from "store/notification/notification-utils";

export type FetchReceipt = typeof fetchReceipt;
export const fetchReceipt = createAsyncThunk<
  ReceiptData,
  { request: AxiosInstance; data: number },
  ThunkAPIConfig
>("receipt/fetchReceipt", async ({ request, data }, thunkapi) => {
  try {
    const result = await request(`${requestUrl.FT_RECEIPT}/${data}`, {
      method: "GET",
    });
    return result.data;
  } catch (e) {
    const errKey = extractError(e, "no_data_found");
    const { isSlideOpen } = thunkapi.getState().common;
    addNotification(thunkapi.dispatch, isSlideOpen, {
      messages: errKey,
      type: "ERROR",
      closable: true,
    });
    return thunkapi.rejectWithValue(null);
  }
});
